const deg2Rad = (deg) => deg * (Math.PI / 180)

const getCoords = (center, radius, degrees, size) => {
    // Make sure degress in inside [1, 360]
    const deg = degrees % 360

    const rad = deg2Rad(deg)

    const x = center.x + radius * Math.cos(rad)
    const y = center.y + radius * Math.sin(rad)

    return {
        x: x + (size / 2) * Math.cos(rad) - (size / 2),
        y: y + (size / 2) * Math.sin(rad) + (size / 2),
        // Correction bc center of coords is in top-left corner
        rotate: deg + 90,
    }
}

export default getCoords
